import { Controller, Shark, Utils } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import "Models/ClientFollowUp";

import followUpComponent from "../../components/followUp/followUpComponent";

class FollowUpManager extends Controller {
	constructor() {
		super("followUpManager");
		this.remoteClassName = "follow-up-for-user";
	}

	delete (item) {
		const rd = NousCore.api.createRequest({ item: { guid: item.guid }});
		const requestedAction = "delete";

		return NousCore.api.send(`follow-up/${requestedAction}`, rd)
		.then(data => {
			console.log(data);
	
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							requestedAction,
							status: "ok",
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	setAsViewed (followUpList) {
		const rd = NousCore.api.createRequest({ items: followUpList.map(item => item.export()) });
		const action = "set-as-viewed";

		return NousCore.api.send(`${this.remoteClassName}/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							status: "ok",
						}
					case 99:
						return {
							data,
							status: "ko",
						}
				}
			}
		});
	}





	
	getListForClient (client) {
		const rd = NousCore.api.createRequest({ item: typeof client === "string" ? {guid: client} : client.export() });

		NousCore.api.send(`${followUpManager.get("nousClassName")}/get-list-for-client`, rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const followUpList = Shark.getInstanceList("ClientFollowUp", data.items);

						//Dave.ToDo: Questo sort lo faccio ogni volta, meglio spostarlo nel componente.
						followUpList.sort((a, b) => {
							if (a.createdAt > b.createdAt) {
								return -1;
							}
							else if (a.createdAt < b.createdAt) {
								return 1;
							}
						});

						// const currProspect = Shark.get("currProspect");
						const targetItem = followUpComponent.get("targetItem");
						targetItem.set("__followUpList", followUpList);
						targetItem.clean("__followUpList");

						// console.log(followUpList)

						followUpManager.emit("listChanged");
						break;
					case 404:
						followUpManager.emit("listGetError");
						break;
				}
			}
		});
	}

	getListForItem (item) {
		const itemName = Utils.camelToDashed(item.__modelName);
		let action;
		let itemToSend;

		switch (itemName) {
			case "client":
				action = `get-full-list-for-client`;
				itemToSend = { guid: item.guid };
				break;
			case "sample-request":
				action = `get-full-list-for-client`;
				itemToSend = { guid: item.contactGuid };
				break;
			case "visit":
				action = `get-full-list-for-client`;
				itemToSend = { guid: item.clientGuid };
				break;
			default:
				action = `get-list-for-${itemName}`;
				itemToSend = item.export();
				delete itemToSend._;
				break;
		}

		const rd = NousCore.api.createRequest({ item: itemToSend });

		console.log("getListForItem", {action});
		
		return NousCore.api.send(`${followUpManager.get("nousClassName")}/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const followUpList = Shark.getInstanceList("ClientFollowUp", data.items);

						//Dave.ToDo: Questo sort lo faccio ogni volta, meglio spostarlo nel componente.
						followUpList.sort((a, b) => {
							if (a.createdAt > b.createdAt) {
								return -1;
							}
							else if (a.createdAt < b.createdAt) {
								return 1;
							}
						});

						followUpList.forEach((item, index) => item.__index = index);

						// const currProspect = Shark.get("currProspect");
						const targetItem = followUpComponent.get("targetItem");
						targetItem.set("__followUpList", followUpList);
						targetItem.clean("__followUpList");

						// console.log(followUpList)

						followUpManager.emit("listChanged");
						return {
							data: followUpList,
							requestedAction: action,
							status: "ok"
						}

					case 404:
						followUpManager.emit("listGetError");
						return {
							data: null,
							error: data.error,
							requestedAction: action,
							status: "ok"
						}

				}
			}
		});
	}

	getListForVisit (visit) {
		const rd = NousCore.api.createRequest({ item: visit.export() });

		NousCore.api.send(`${followUpManager.get("nousClassName")}/get-list-for-visit`, rd, function (data) {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const followUpList = Shark.getInstanceList("ClientFollowUp", data.items);

						//Dave.ToDo: Questo sort lo faccio ogni volta, meglio spostarlo nel componente.
						followUpList.sort((a, b) => {
							if (a.createdAt > b.createdAt) {
								return -1;
							}
							else if (a.createdAt < b.createdAt) {
								return 1;
							}
						});

						// const currProspect = Shark.get("currProspect");
						// const currVisit = followUpComponent.get("targetClient");
						const currVisit = followUpComponent.get("targetItem");
						currVisit.set("__followUpList", followUpList);
						currVisit.clean("__followUpList");

						// console.log(followUpList)

						followUpManager.emit("listChanged");
						break;
					case 404:
						followUpManager.emit("listGetError");
						break;
				}
			}
		});
	}

	save (clientFollowUp) {
		const rd = NousCore.api.createRequest({ item: clientFollowUp.export() });
		const action = clientFollowUp.guid === "" ? "insert" : "update";

		return NousCore.api.send(`${followUpManager.get("nousClassName")}/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						clientFollowUp.import(data.items[0]);
						clientFollowUp.clean();

						if (action === "insert" && clientFollowUp.type !== "system") {//In linea di massima se è di tipo system viene inserito senza il pannello attivo e quindi non devo cercare il target item.
							const targetItem = followUpComponent.get("targetItem");

							if (targetItem) {
								const followUpList = targetItem.__followUpList.map(item => item);

								followUpList.unshift(clientFollowUp);
								targetItem.set("__followUpList", followUpList);
								targetItem.clean("__followUpList");
							}
						}

						followUpManager.emit("saved");
						if (clientFollowUp.type !== "system") {
							followUpManager.emit("listChanged", "fromSave");
						}
						else {
							followUpManager.emit("listChanged", "isSystem");
						}
						return {
							data: clientFollowUp,
							status: "ok",
						}
						break;
					case 99:
						followUpManager.emit("saveError");
						return {
							data: "",
							status: "ko",
						}
						break;
				}
			}
		});
	}
}

const followUpManager = new FollowUpManager();

followUpManager.set("nousClassName", "follow-up");

Shark.registerController(followUpManager);

export default followUpManager;
